<template>
    <div style="">
        <!-- Variant Protein -->

        <span style="width:100%;" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">
            <NavBar_Gene v-bind:item="item"></NavBar_Gene>
        </span>

        <span style="width:100%;" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">

                    <v-row align="center" justify="center" id="result-download">
                        <v-col cols="12" md="12" lg="12" xl="12" justify="center" align="center" style="">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div v-if="this.$store.getters.isLoading" class="loading-spinner">
                              <div class="spinner"></div>
                              <div>Loading</div>
                            </div>
                        </v-col>
                    </v-row>
        </span>

                    <div style="border:0px solid #f5f5f5;width:100%;">

                        <v-row>
                             <v-col cols="12" md="12" lg="4" xl="4" style="text-align:center;">

                                <span style="width:100%;" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">
                                    <div style="margin-left:20px;text-align:left;">
                                        <h3 class="text-h5 font-weight-light" style="margin:0;padding:0;">
                                            Transcripts
                                        </h3>
                                    </div>
                                </span>

                                <span style="width:100%;" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">
                                                    <!--<div class="content-box-toolbar-div" style="">
                                                            <v-toolbar class="rounded-lg elevation-2" dark color="#f5f5f5" style="text-align:left;height:35px;" density="compact">
                                                                 <v-toolbar-title style="font-size:14px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                                       Transcripts
                                                                 </v-toolbar-title>
                                                            </v-toolbar>
                                                         </div>-->
                                                         <v-card class="elevation-2 content-box"  style="margin-top:10px;padding-top:10px;margin-left:10px;padding-left:10px;padding-right:10px;">
                                                         <!--<div class="content-box-header-space"></div>-->

                                                            <span v-if="'gencode' in item">
                                                                <v-select
                                                                    v-model="item.gencode.MANE_Select_transcript"
                                                                    :items="Object.keys(item.gencode.transcripts)"
                                                                    @update:modelValue="update_active_transcript"
                                                                    >
                                                                </v-select>
                                                            </span>

                                                            <span v-if="'tag' in this.$store.getters.activeTranscript">
                                                                <v-table v-if="this.$store.getters.activeTranscript.tag.includes('MANE_Select')" style="text-align:left;padding:10px;width:100%;">
                                                                    <tr v-if="'UTA_Adapter_protein_sequence' in item">
                                                                        <td style="width:150px;">Transcript</td>
                                                                        <td>
                                                                            <a v-bind:href="'https://www.ncbi.nlm.nih.gov/nuccore/'+item.UTA_Adapter_protein_sequence.transcript">
                                                                                {{ item["UTA_Adapter_protein_sequence"]["transcript"] }}
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-if="'UTA_Adapter_gene' in item">
                                                                        <td>cDNA</td><td>{{ item["UTA_Adapter_gene"]["c_dna_string"] }}</td>
                                                                    </tr>
                                                                    <tr v-if="'UTA_Adapter_gene' in item">
                                                                        <td>cds start/end</td>{{ item["UTA_Adapter_gene"]["cds_start"] }} - {{ item["UTA_Adapter_gene"]["cds_end"] }}<td></td>
                                                                    </tr>
                                                                    <!--<tr><td>refAmino</td><td>{{ item["UTA_Adapter_gene"]["refAmino"] }}</td></tr>
                                                                    <tr>
                                                                        <td>protLoction</td><td>{{ item["UTA_Adapter_gene"]["prot_location"] }}</td>
                                                                    </tr>
                                                                    -->
                                                                    <tr v-if="'UTA_Adapter_gene' in item">
                                                                        <td>Nucleotide change</td><td>{{ item["UTA_Adapter_gene"]["nucleotide_change"] }}</td>
                                                                    </tr>
                                                                    <tr><td>Type</td>
                                                                        <td>
                                                                            <span v-if="'oncokb' in item">
                                                                                <span v-if="'oncokb' in item['oncokb']">
                                                                                    <span v-if="'exact_match' in item['oncokb']['oncokb']">
                                                                                        <span v-if="'query' in item['oncokb']['oncokb']['exact_match']">
                                                                                            {{ item["oncokb"]["oncokb"]["exact_match"]["query"]["consequence"] }}
                                                                                        </span>
                                                                                    </span>
                                                                                </span>
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                </v-table>
                                                                <v-table v-if="'transcript_name' in this.active_transcript" style="text-align:left;padding:10px;width:100%;">
                                                                    <tr v-if="'transcript_name' in this.active_transcript">
                                                                        <td style="width:150px;">Transcript name</td>
                                                                        <td>{{ this.active_transcript.transcript_name }}</td>
                                                                    </tr>
                                                                    <tr v-if="'transcript_type' in this.active_transcript">
                                                                        <td style="width:150px;">Transcript type</td>
                                                                        <td>{{ this.active_transcript.transcript_type }}</td>
                                                                    </tr>

                                                                    <tr v-if="' start_pos' in this.active_transcript">
                                                                        <td>Start-End position</td>
                                                                        <td>{{ this.active_transcript[" seqname"] }}:{{ this.active_transcript[" start_pos"] }}-{{ this.active_transcript[" end_pos"] }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="width:40px;">Protein</td>
                                                                        <td v-if="'UTA_Adapter_protein_sequence' in item">
                                                                            {{ item['UTA_Adapter_protein_sequence']['protein_id'] }}
                                                                        </td>
                                                                    </tr>
                                                                </v-table>

                                                                <!-- Exons -->
                                                                <!--<v-list density="compact" class="elevation-1" style="text-align:left;padding:0px;margin:0px;padding-right:10px;font-size:12px;" >
                                                                    <v-list-group value="metakb" dark color="#0086d0"  style="text-align:left;padding:0px;" density="compact">
                                                                        <template v-slot:activator="{ props }">
                                                                            <v-list-item
                                                                                v-bind="props"
                                                                                title="Exons"
                                                                                density="compact"
                                                                                style="font-size:12px;"
                                                                            ></v-list-item>
                                                                        </template>

                                                                         <v-card class="elevation-0 content-box"  style="">
                                                                            <v-table v-if="'exon' in this.active_transcript" v-for="exon in this.active_transcript.exon" style="text-align:left;padding:10px;width:100%;">
                                                                                    <tr>
                                                                                        <td>Exon ID</td><td>{{ exon.exon_id }}</td>
                                                                                        <td>Exon Number</td><td>{{ exon.exon_number }}</td>
                                                                                    </tr>
                                                                                    <tr><td>Start-End position (hg38/GRCh38)</td><td>{{ exon[" start_pos"] }} - {{ exon[" end_pos"] }}</td></tr>
                                                                            </v-table>
                                                                         </v-card>
                                                                    </v-list-group>
                                                               </v-list>-->

                                                                <!-- CDS -->

                                                                <div style="padding-top:20px;padding-bottom:10px;">
                                                                    <div v-if="'hgnc_id' in this.active_transcript" style="padding-left:10px;">
                                                                        <a style="font-size:12px;"
                                                                            v-bind:href="'https://varsome.com/gene/hg38/'+this.active_transcript.hgnc_id"
                                                                        >
                                                                        Show Varsome entry ({{ this.active_transcript.hgnc_id }})
                                                                        </a>
                                                                    </div>

                                                                <div v-if="'transcript_id' in this.active_transcript" style="padding-left:10px;">
                                                                                <a style="font-size:12px;"
                                                                                    v-bind:href="'http://www.ensembl.org/Homo_sapiens/Transcript/Summary?db=core;t='+this.active_transcript.transcript_id">
                                                                                    Show Ensembl entry ({{ this.active_transcript.transcript_id }})
                                                                                </a>
                                                                </div>

                                                                <div v-if="'hgnc_id' in this.active_transcript" style="padding-left:10px;">
                                                                        <a style="font-size:12px;"
                                                                            v-bind:href="'https://www.genenames.org/data/gene-symbol-report/#!/hgnc_id/'+this.active_transcript.hgnc_id"
                                                                        >
                                                                        Show Genenames entry ({{ this.active_transcript.hgnc_id }})
                                                                        </a>
                                                                </div>
                                                                </div>

                                                        </span>






                                                               <!-- Exons -->
                                                                <v-list density="compact" class="elevation-1" style="text-align:left;padding:0px;margin:0px;padding-right:10px;font-size:12px;" >
                                                                    <v-list-group value="metakb" dark color="#0086d0"  style="text-align:left;padding:0px;" density="compact">
                                                                        <template v-slot:activator="{ props }">
                                                                            <v-list-item
                                                                                v-bind="props"
                                                                                title="Exons"
                                                                                density="compact"
                                                                                style="font-size:12px;"
                                                                            ></v-list-item>
                                                                        </template>

                                                                         <v-card class="elevation-0 content-box"  style="">
                                                                            <v-table v-if="'exon' in this.active_transcript" v-for="exon in this.active_transcript.exon" style="text-align:left;padding:10px;width:100%;">
                                                                                    <tr>
                                                                                        <td>Exon ID</td><td>{{ exon.exon_id }}</td>
                                                                                    </tr><tr>
                                                                                        <td>Exon Number</td><td>{{ exon.exon_number }}</td>
                                                                                    </tr>
                                                                                    <tr><td>Start-End position (hg38/GRCh38)</td><td>{{ exon[" start_pos"] }} - {{ exon[" end_pos"] }}</td></tr>
                                                                            </v-table>
                                                                         </v-card>
                                                                    </v-list-group>
                                                               </v-list>

                                                                <!-- CDS -->

                                                  </v-card>
                                            </span>

                                        </v-col>

                            <v-col cols="12" md="12" lg="8" xl="8" justify="center" align="center" style="">

                                        <div style="margin-left:20px;text-align:left;">
                                            <p ref="graph" style="font-size:16px;">
                                                Protein sequence
                                            </p>

                                        <div v-if="'protein_sequence' in this.active_transcript" v-html="pseq" ref="protseq" :sequence="pseq">
                                        </div>
                                        <div style="width:90%;margin:auto;">
                                            <a class="pseq-link" style="margin:10px;color:#3a3a3a;" @click="copySequence">
                                                    <v-icon icon="mdi-content-copy" size="1rem" />
                                                        Copy to clipboard
                                            </a>
                                        </div>
                                        </div>
                            </v-col>

                        </v-row>
                    </div>


                    <div style="height:40px;">
                    </div>

        <Loading v-model:active="isLoading" v-model="fullPage" :can-cancel="true" :is-full-page="fullPage" />

    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import NavBar_Gene from '@/components/navbars/NavBar_Gene';
import active_variants from "@/methods/active_variants";
import { ref } from 'vue';
import variant_annotation from "@/methods/variant_annotation";

import Plotly from  '@/assets/js/plotly-latest.min.js';
import axios from 'axios';
import * as $3Dmol from '3dmol'
import '@/assets/js/3Dmol.ui-min.js'
import { mapGetters } from 'vuex'
import useTooltip from '@/methods/tooltip.js';


export default {
    name: 'VariantProtein',
    props: {
    },
    components: {
        Loading,
        NavBar_Gene,
    },
    setup() {
        return {
            seq: ref('AAAGAGGATAACACTAGCA'),
            annotations: ref([
                {
                    name: "promoter",
                    start: 9,
                    end: 12,
                    direction: 1
                },
                {
                    name: "promoter",
                    start: 3,
                    end: 6,
                    direction: 1
                },
                {
                    name: "promoter",
                    start: 0,
                    end: 3,
                    direction: 1
                }
            ])
        }
    },
    data: function () {
        return {
            isLoading: false,
            fullPage: true,
            show: false,
            protein_legend: {"data": [{"line": {"shape": "spline"}, "marker": {"color": "#2ca02c", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [0.0, 0.18181818181818182, 0.36363636363636365, 0.5454545454545454, 0.7272727272727273, 0.9090909090909092, 1.0909090909090908, 1.2727272727272727, 1.4545454545454546, 1.6363636363636365, 1.8181818181818183, 2.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"line": {"shape": "spline"}, "marker": {"color": "#d62728", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [13.0, 13.181818181818182, 13.363636363636363, 13.545454545454545, 13.727272727272727, 13.90909090909091, 14.09090909090909, 14.272727272727273, 14.454545454545455, 14.636363636363637, 14.818181818181818, 15.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"line": {"shape": "spline"}, "marker": {"color": "#e377c2", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [22.0, 22.181818181818183, 22.363636363636363, 22.545454545454547, 22.727272727272727, 22.90909090909091, 23.09090909090909, 23.272727272727273, 23.454545454545453, 23.636363636363637, 23.81818181818182, 24.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"line": {"shape": "spline"}, "marker": {"color": "#8c564b", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [30.0, 30.181818181818183, 30.363636363636363, 30.545454545454547, 30.727272727272727, 30.90909090909091, 31.09090909090909, 31.272727272727273, 31.454545454545453, 31.636363636363637, 31.81818181818182, 32.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"fill": "toself", "fillcolor": "#1f77b4", "hoverinfo": "skip", "line": {"color": "#1f77b4"}, "mode": "lines", "opacity": 1, "x": [45, 44, 44, 45], "y": [1, 1.8, 0.19999999999999996, 1], "type": "scatter"}, {"hoverinfo": "skip", "line": {"color": "#1f77b4", "width": 25}, "mode": "lines", "x": [43, 44], "y": [1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#1f77b4", "size": 3}, "text": ["B: Isolated beta-bridge residue<br>position: 43<br>"], "x": [43, 44, 45], "y": [1, 1, 1], "type": "scatter"}, {"fill": "toself", "fillcolor": "#9467bd", "hoverinfo": "skip", "line": {"color": "#9467bd"}, "mode": "lines", "opacity": 1, "x": [63, 62, 62, 63], "y": [1, 1.8, 0.19999999999999996, 1], "type": "scatter"}, {"hoverinfo": "skip", "line": {"color": "#9467bd", "width": 25}, "mode": "lines", "x": [61, 62], "y": [1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#9467bd", "size": 3}, "text": ["E: Strand<br>position: 61<br>"], "x": [61, 62, 63], "y": [1, 1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "black", "size": 3}, "mode": "lines+markers", "text": ["-: None<br>position: 69<br>"], "x": [69, 70, 71], "y": [1, 1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#ff7f0e ", "size": 3}, "mode": "lines+markers", "text": ["S: Bend<br>position: 77<br>"], "x": [77, 78, 79], "y": [1, 1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#17becf", "size": 3}, "mode": "lines+markers", "text": ["T: Turn<br>position: 85<br>"], "x": [85, 86, 87], "y": [1, 1, 1], "type": "scatter"}], "layout": {"template": {"data": {"barpolar": [{"marker": {"line": {"color": "white", "width": 0.5}, "pattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}}, "type": "barpolar"}], "bar": [{"error_x": {"color": "#2a3f5f"}, "error_y": {"color": "#2a3f5f"}, "marker": {"line": {"color": "white", "width": 0.5}, "pattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}}, "type": "bar"}], "carpet": [{"aaxis": {"endlinecolor": "#2a3f5f", "gridcolor": "#C8D4E3", "linecolor": "#C8D4E3", "minorgridcolor": "#C8D4E3", "startlinecolor": "#2a3f5f"}, "baxis": {"endlinecolor": "#2a3f5f", "gridcolor": "#C8D4E3", "linecolor": "#C8D4E3", "minorgridcolor": "#C8D4E3", "startlinecolor": "#2a3f5f"}, "type": "carpet"}], "choropleth": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "type": "choropleth"}], "contourcarpet": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "type": "contourcarpet"}], "contour": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "contour"}], "heatmapgl": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "heatmapgl"}], "heatmap": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "heatmap"}], "histogram2dcontour": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "histogram2dcontour"}], "histogram2d": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "histogram2d"}], "histogram": [{"marker": {"pattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}}, "type": "histogram"}], "mesh3d": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "type": "mesh3d"}], "parcoords": [{"line": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "parcoords"}], "pie": [{"automargin": true, "type": "pie"}], "scatter3d": [{"line": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatter3d"}], "scattercarpet": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattercarpet"}], "scattergeo": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattergeo"}], "scattergl": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattergl"}], "scattermapbox": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattermapbox"}], "scatterpolargl": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatterpolargl"}], "scatterpolar": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatterpolar"}], "scatter": [{"fillpattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}, "type": "scatter"}], "scatterternary": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatterternary"}], "surface": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "surface"}], "table": [{"cells": {"fill": {"color": "#EBF0F8"}, "line": {"color": "white"}}, "header": {"fill": {"color": "#C8D4E3"}, "line": {"color": "white"}}, "type": "table"}]}, "layout": {"annotationdefaults": {"arrowcolor": "#2a3f5f", "arrowhead": 0, "arrowwidth": 1}, "autotypenumbers": "strict", "coloraxis": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "colorscale": {"diverging": [[0, "#8e0152"], [0.1, "#c51b7d"], [0.2, "#de77ae"], [0.3, "#f1b6da"], [0.4, "#fde0ef"], [0.5, "#f7f7f7"], [0.6, "#e6f5d0"], [0.7, "#b8e186"], [0.8, "#7fbc41"], [0.9, "#4d9221"], [1, "#276419"]], "sequential": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "sequentialminus": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}, "colorway": ["#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52"], "font": {"color": "#2a3f5f"}, "geo": {"bgcolor": "white", "lakecolor": "white", "landcolor": "white", "showlakes": true, "showland": true, "subunitcolor": "#C8D4E3"}, "hoverlabel": {"align": "left"}, "hovermode": "closest", "mapbox": {"style": "light"}, "paper_bgcolor": "white", "plot_bgcolor": "white", "polar": {"angularaxis": {"gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": ""}, "bgcolor": "white", "radialaxis": {"gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": ""}}, "scene": {"xaxis": {"backgroundcolor": "white", "gridcolor": "#DFE8F3", "gridwidth": 2, "linecolor": "#EBF0F8", "showbackground": true, "ticks": "", "zerolinecolor": "#EBF0F8"}, "yaxis": {"backgroundcolor": "white", "gridcolor": "#DFE8F3", "gridwidth": 2, "linecolor": "#EBF0F8", "showbackground": true, "ticks": "", "zerolinecolor": "#EBF0F8"}, "zaxis": {"backgroundcolor": "white", "gridcolor": "#DFE8F3", "gridwidth": 2, "linecolor": "#EBF0F8", "showbackground": true, "ticks": "", "zerolinecolor": "#EBF0F8"}}, "shapedefaults": {"line": {"color": "#2a3f5f"}}, "ternary": {"aaxis": {"gridcolor": "#DFE8F3", "linecolor": "#A2B1C6", "ticks": ""}, "baxis": {"gridcolor": "#DFE8F3", "linecolor": "#A2B1C6", "ticks": ""}, "bgcolor": "white", "caxis": {"gridcolor": "#DFE8F3", "linecolor": "#A2B1C6", "ticks": ""}}, "title": {"x": 0.05}, "xaxis": {"automargin": true, "gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": "", "title": {"standoff": 15}, "zerolinecolor": "#EBF0F8", "zerolinewidth": 2}, "yaxis": {"automargin": true, "gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": "", "title": {"standoff": 15}, "zerolinecolor": "#EBF0F8", "zerolinewidth": 2}}}, "annotations": [{"font": {"size": 15}, "showarrow": false, "text": "H: Alpha helix (4-12)", "x": 2.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "G: 3-10 helix", "x": 15.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "I: Pi helix", "x": 24.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "P: Poly-Proline helix", "x": 32.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "B: Isolated beta-bridge residue", "x": 45.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "E: Strand", "x": 63.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "-: None", "x": 71.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "S: Bend", "x": 79.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "T: Turn", "x": 87.5, "xanchor": "left", "y": 1}], "hovermode": false, "showlegend": false, "title": {"text": "Legend of secondary structures"}, "yaxis": {"visible": true, "showticklabels": false, "showline": true, "linewidth": 3, "linecolor": "black", "mirror": true, "showgrid": false, "zeroline": false}, "xaxis": {"visible": true, "showticklabels": false, "range": [-0.5, 93], "showline": true, "linewidth": 3, "linecolor": "black", "mirror": true, "showgrid": false, "zeroline": false}, "height": 110, "margin": {"t": 30, "b": 5, "pad": 0}}},
            pmol: '',
            active_transcript: {},
            active_protein: '',
            mutated_patho : 'grey',
            dialog_protein_patho: false,
            dialog_protein_binding: false,
            dialog_protein_mutated: false,
            prot_seq_cols: 5,
            pdb_data: '',
            pdb_bs_data: '',
            pid: '',
        }
    },
      errorCaptured(err, vm, info) {
    console.log('Error Captured:', err);
    return false;  // Prevents the error from propagating further
  },
    methods: {
        download_pdb() {
          // Create a blob from the content
          const blob = new Blob([this.pdb_data], { type: 'text/plain' });

          // Create a temporary URL for the blob
          const url = URL.createObjectURL(blob);

          // Create a temporary <a> element to trigger the download
          const link = document.createElement('a');
          link.href = url;

          // Set the file name (you can customize the file name here)
          link.download = this.pid + '_structure.pdb';

          // Append the link to the body (required for some browsers)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by revoking the object URL and removing the temporary link
          URL.revokeObjectURL(url);
          document.body.removeChild(link);
        },
        download_pdb_bs() {
          // Create a blob from the content
          const blob = new Blob([this.pdb_bs_data], { type: 'text/plain' });

          // Create a temporary URL for the blob
          const url = URL.createObjectURL(blob);

          // Create a temporary <a> element to trigger the download
          const link = document.createElement('a');
          link.href = url;

          // Set the file name (you can customize the file name here)
          link.download = this.pid + '_structure_binding_sites.pdb';

          // Append the link to the body (required for some browsers)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by revoking the object URL and removing the temporary link
          URL.revokeObjectURL(url);
          document.body.removeChild(link);
        },
        defineColumns() {
          const width = window.innerWidth;

          // Define number of columns based on screen width
          if (width < 600) {
            this.prot_seq_cols = 1; // Mobile devices
          } else if (width >= 600 && width < 900) {
            this.prot_seq_cols = 2; // Small tablets
          } else if (width >= 900 && width < 1200) {
            this.prot_seq_cols = 3; // Tablets
          } else if (width >= 1200 && width < 1600) {
            this.prot_seq_cols = 4; // Medium screens
          } else {
            this.prot_seq_cols = 5; // Large screens
          }
        },
        showTooltip (element_id, tooltip_id, tooltip_title = undefined) {
            useTooltip.fireTooltipEvent(element_id, tooltip_id, tooltip_title);
        },
        async copySequence() {
          let cpText = ">Seq"+ this.active_transcript.transcript_id + " [organism=Homo sapiens]\n" + this.active_transcript.protein_sequence
          await navigator.clipboard.writeText(cpText);
        },
        format_protein_sequence(pseq) {
                    let mark_pos = false
                    if ("tag" in this.active_transcript) {
                        if (this.active_transcript.tag.includes("MANE_Select")) {
                            mark_pos = true
                        }
                    }

                    const prot_seq_length = 5

                    let pseq_arr = pseq.match(/.{1,10}/g);

                    let row_c = 0
                    let protloc = 0
                    let color='#e4eff2'
                    let arr_str = ''
                    let ic = 0
                    let rows = 0
                    let aa_section= 0
                    let pseq_str = ''
                    //let isVariant = false
                    let aa = ""
                    //alert(JSON.stringify(this.activeBiomarker))

                    pseq_str += '<div style="width:90%;margin:auto;padding:20px;background-color:#e4eff2;"><div style="margin:20px;">Seq'+this.active_transcript.transcript_id+' [organism=Homo sapiens] </div>'

                    pseq_str += '<table style="white-space: pre-wrap;font-family:monospace;margin:20px;width:600px;"><tr>'
                    //pseq_str += '<v-row style="width:100%;">'
                    //pseq_str += '<v-col cols="6" md="6" lg="2" xl="2" style="text-align:center;">'

                    for (let i = 0;i< pseq_arr.length; i += 1) {
                        aa_section = aa_section + 10

                        //pseq_str += '<v-col cols="6" md="6" lg="2" xl="2" style="border:1px solid red;text-align:center;">'
                        pseq_str += '<td style="white-space: pre-wrap;font-family:monospace;padding-right:40px;margin-left:10px;margin-right:30px;">'

                        pseq_str += '<table><tr><td style="text-align:right;color:#6a6a6a;">' + aa_section + '</td></tr><tr><td>'

                        arr_str = pseq_arr[i]
                        //pseq_str += pseq_arr[i]
                        for (let j =0;j<arr_str.length; j++) {
                            protloc++;
                            aa = arr_str[j]
                            color='#e4eff2'
                            pseq_str += '<span style="padding:2px;margin-left:2px; margin-right:2px;background-color:'+color+';">' + aa + '</span>'

                        }

                        pseq_str += '</td></tr></table>'
                        pseq_str +='</td>'
                        //pseq_str += '</v-col>'

                        row_c += 1
                        //protloc += 6
                        if (row_c == this.prot_seq_cols) {
                            rows++
                            pseq_str += '</tr><tr>'
                            //pseq_str += '</v-col><v-col>'
                            //pseq_str += '</v-row><v-row>'
                            //pseq_str += '<td>' + aa_section + '</td>'
                            row_c = 0
                        }
                    }
                    pseq_str += '</tr></table></div>'
                    //pseq_str += '</v-row>'
                    pseq_str +='</div>'
                    this.pseq = pseq_str
                    //alert(pseq_str)
                    return pseq_str
            },
         async loadProteinData() {
            let url=this.$store.getters.getPathVariable('methods_generate_plot')
            let formData = new FormData();
            let variant_protein_data = {}

            variant_protein_data["UTA_Adapter"] = {}
            variant_protein_data["UTA_Adapter"]["gene_name"] = this.$store.getters.getActiveBiomarker[Object.keys(this.$store.getters.getActiveBiomarker)[0]]["UTA_Adapter"]["gene_name"]
            variant_protein_data["UTA_Adapter"]["variant_exchange"] = this.$store.getters.getActiveBiomarker[Object.keys(this.$store.getters.getActiveBiomarker)[0]]["UTA_Adapter"]["variant_exchange"]
            formData.append("variant_data", JSON.stringify(variant_protein_data) )
            formData.append("plot", "protein-data");

            await axios.post(url, formData, {
              headers: {
                "Content-Type": "text/html"
              }
            }).then((response) => {
                var response = response.data
                if (response.length > 0) {
                    try {
                        var graphJSON = response[0]["data"]["plot_json"]

                        Plotly.plot('protein_plot',graphJSON,graphJSON);
                        Plotly.plot('protein_legend',this.protein_legend,this.protein_legend)
                        this.$store.dispatch('setProcessState', [  "load-radar-0-thumb","" ] )
                    } catch (error) {
                        console.log(error)
                    }
                } else{
                    console.log("Error: Could not retrieve protein feature data")
                }
            })
        },
        getGencodeAttributes(item) {
            //alert(JSON.stringify(item))
            return item, {}
        },
        update_active_protein(val) {
            //alert(JSON.stringify(this.active_transcript.pdb_ids))
            //this.$store.dispatch("setActiveTranscript",this.active_transcript)

            //this.active_protein = this.active_transcript.pdb_ids[0]
            this.active_protein = val
            //alert(this.active_protein)
            this.$store.dispatch("setActiveProtein",this.active_protein)
            //alert(JSON.stringify(this.active_transcript))
            //alert(this.active_transcript.transcript_id)
            //this.loadProteinViewers()

            //this.format_protein_sequence(this.active_transcript.protein_sequence,
            //        this.$store.getters.getActiveBiomarker[key].UTA_Adapter_gene.prot_location
            //    )
        },
        update_active_transcript(val) {
            for (let key of Object.keys(this.$store.getters.getActiveBiomarker)) {
                let activeBiomarker = this.$store.getters.getActiveBiomarker
                //alert(key + JSON.stringify(Object.keys(activeBiomarker)))
                this.active_transcript=this.$store.getters.getActiveBiomarker[key].gencode.transcripts[val]
                this.$store.dispatch("setActiveTranscript",this.active_transcript)
                //alert(JSON.stringify(this.active_transcript))
                //alert(this.active_transcript.transcript_id)
                //this.loadProteinViewers()

                activeBiomarker = activeBiomarker[Object.keys(activeBiomarker)[0]]
                //alert(JSON.stringify(activeBiomarker))
                if ("gencode" in activeBiomarker) {
                    let pseq = activeBiomarker.gencode.MANE_Select_transcript
                    this.format_protein_sequence(this.active_transcript.protein_sequence)
                }
            }
        },
        getCAAtomCoordinates(data, resn, resi) {
            // Split the PDB data into lines
            var lines = data.split('\n');

            // Initialize variables to store the coordinates
            var x = 0;
            var y = 0;
            var z = 0;

            // Convert the input resi to a number
            var targetResi = parseInt(resi);

            // Iterate through each line to find the CA atom for the specified amino acid residue
            for (var i = 0; i < lines.length; i++) {
                var line = lines[i].trim();

                // Check if the line represents an atom entry (ATOM or HETATM)
                if ((line.startsWith('ATOM') || line.startsWith('HETATM')) && (line.substr(13, 4).trim() === 'CA')) {
                    // Extract amino acid residue information from the line
                    var lineResn = line.substr(17, 3).trim();
                    var lineResi = parseInt(line.substr(23, 4).trim());

                    // Check if the current atom matches the specified amino acid residue
                    if (lineResn === resn && lineResi === targetResi) {
                        console.log(line)
                        //alert(line)
                        // Extract x, y, and z coordinates
                        x = parseFloat(line.substr(31, 7).trim());
                        y = parseFloat(line.substr(39, 7).trim());
                        z = parseFloat(line.substr(47, 7).trim());

                        // Break out of the loop since we found the coordinates
                        break;
                    }
                }
            }

            // Return the coordinates as an object
            return { x: x, y: y, z: z };
        },
                Interpolate(start, end, steps, count) {
                    var s = start,
                        e = end,
                        final = s + (((e - s) / steps) * count);
                    return Math.floor(final);
                },

                Color(_r, _g, _b) {
                    var r, g, b;
                    var setColors = function(_r, _g, _b) {
                        r = _r;
                        g = _g;
                        b = _b;
                    };

                    setColors(_r, _g, _b);
                    this.getColors = function() {
                        var colors = {
                            r: r,
                            g: g,
                            b: b
                        };
                        return colors;
                    };
                },

    },
    created: async function () {

    },
    mounted: async function () {
        this.isLoading=true
        this.$store.dispatch("setIsLoading", true)

        await active_variants.loadActiveBiomarkerGene(this.$route.params.id)
        this.isLoading=false
        //alert(JSON.stringify(this.$store.getters.getActiveBiomarker))

        //for (const [key,item] of Object.entries(this.$store.getters.getActiveBiomarker)) {

        //await this.loadProteinData()
        let activeBiomarker = this.$store.getters.getActiveBiomarker
        activeBiomarker = activeBiomarker[Object.keys(activeBiomarker)[0]]

        this.defineColumns()
        if ("gencode" in activeBiomarker) {
            await this.update_active_transcript(activeBiomarker.gencode.MANE_Select_transcript)
            //this.loadProteinViewers()
            await this.loadProteinData()
        }
        //}
        this.isLoading = false
        this.$store.dispatch("setIsLoading", false)

    },
    computed: {
        ...mapGetters([
            'activeTranscript'
        ])
    },
    watch: {
        activeTranscript: {
            handler(newTranscript) {
                //alert("new transcript: ",newTranscript)
                //this.loadProteinViewers()
            }
        }
    },
}
</script>
<style>
.v-card-title {
    font-size:16px;font-weight:300;padding:0;margin:0;margin-left:10px;
}
v-table hd + td { border-left:1px solid #dddddd; }
.pseq-link {

}

.pseq-link:hover {
    cursor: pointer;
}

.table-title {
    font-size: var(--font-600);
    font-family: var(--default-font);
    text-align: left;
    font-weight: 300;
}

.loading-spinner {
  margin-top: 20px;
  text-align:center;
}

.spinner {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

</style>
